import { render, staticRenderFns } from "./AccessDeniedView.vue?vue&type=template&id=0cb95aee&"
import script from "./AccessDeniedView.vue?vue&type=script&lang=js&"
export * from "./AccessDeniedView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports